import React from 'react';
import { useTranslation } from 'react-i18next';
import { CellTitle } from '@root/components/Cell';
import { IPayMethodProps } from '@root/hooks/usePayMethod';

import './style.less';

const PayMethod = ({ methodList, payMethod, onSelect }: IPayMethodProps) => {
  const { t } = useTranslation();

  if (!methodList.length) {
    return null;
  }

  return (
    <>
      <CellTitle>{t('Payment_method')}</CellTitle>
      <div className="payment-method">
        {methodList.map((item) => {
          return (
            <div
              key={item.value}
              className={`payment-method-item ${
                payMethod === item.value ? 'active' : ''
              }`}
              onClick={() => onSelect(item.value)}
            >
              <img src={item.icon} />
              <p>{item.title}</p>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default PayMethod;
